import { useQuery } from "@tanstack/react-query";
import { reportReplacementApi } from "./axios";
import { DataI, ServiceResponseI, ReportReplacementI } from "../../interfaces";
import { ValidateCurrentToken, LogoutSystem } from "../../helpers";
import { AxiosError } from "axios";

export const getAllReportReplacementbyEquipmentId = async (
  equipment: number
): Promise<ServiceResponseI<ReportReplacementI[]>> => {
  try {
    const validateToken = ValidateCurrentToken();
    if (!validateToken) throw new Error("TOKEN INVALIDO");

    const { data } = await reportReplacementApi.get<
      ServiceResponseI<ReportReplacementI[]>
    >(`/all-replacement-by-equipment-id/${equipment}`, {
      headers: { Authorization: validateToken },
    });

    return data;
  } catch (err) {
    const obj = (err as AxiosError).response;
    if (obj?.status === 401) {
      LogoutSystem();
    }
    throw new Error((err as Error).message);
  }
};

export const useAllReportReplacementbyEquipmentIdQuery = (id: number) => {
  const queryReplacements = useQuery({
    queryKey: ["report", "replacement", id],
    queryFn: () => getAllReportReplacementbyEquipmentId(id),
    staleTime: 1000 * 60 * 60 * 6, // 6 HORAS
  });

  return {
    queryReplacements,
  };
};
